var Routes = (function () {
    function Routes() {
    }
    Routes.HOME = '/';
    Routes.DASHBOARD = '/dashboard';
    Routes.APPOINTMENTS = '/appointments';
    Routes.CALENDAR = '/calendar';
    Routes.CUSTOMERS = '/clients';
    Routes.INVOICES = '/invoices';
    Routes.MERCHANT = '/business/profile';
    Routes.MERCHANT_PROFILE = '/business/profile';
    Routes.MERCHANT_EMPLOYEES = '/business/employees';
    Routes.MERCHANT_SALES = '/business/sales';
    Routes.MERCHANT_SERVICES = '/business/services';
    Routes.MERCHANT_SERVICE_CATEGORIES = '/business/services/categories';
    Routes.MERCHANT_LOCATIONS = '/business/locations';
    Routes.MERCHANT_TEMPLATES = '/business/templates';
    Routes.MERCHANT_NOTIFICATIONS = '/business/notifications';
    return Routes;
}());
export default Routes;
